import { SelectProps as AntdSelectProps } from 'antd';
import SelectStyled from './styles';

const { Option } = SelectStyled;

export type SelectProps<T> = AntdSelectProps<T> & {
  options: { value: string | number; label: string }[];
};

export function Select<T = {}>({ options, ...props }: SelectProps<T>) {
  return (
    // @ts-ignore
    <SelectStyled bordered={false} {...props} suffixIcon={<i className="triangle-down " />}>
      {options.map((item) => (
        <Option key={item.value} value={item.value}>
          <div className="content-option">{item.label}</div>
        </Option>
      ))}
    </SelectStyled>
  );
}

export default Select;
